const LicPackageLevels = {
    NO_ACCESS: null,
    BASIC: "BASIC",
    EXTENDED: "EXTENDED"
};

module.exports = LicPackageLevels;
